(function () {
    "use strict";

    let app = angular.module("app");

    app.service("userApi", service);

    service.$inject = ["ENV", "request", "$q", "$rootScope", "$http", "version", "auth"];

    function service(ENV, request, $q, $rootScope, $http, version, auth) {
        const headers = {'synkedup-version': `web ${version}`}

        const forgotPassword = (data) => {
            var url = `${ENV.apiEndpoint}/account/forgot-password`;
            return $http.post(url, data, { headers })
                .then((res) => {
                    return res.data
                })
        }

        const resetPassword = (data) => {
            var url = `${ENV.apiEndpoint}/account/reset-password`;
            return $http.post(url, data, { headers })
                .then((res) => {
                    return res.data
                })
        }

        const getUserInfo = () => {
            var url = `${ENV.apiEndpoint}/account`;
            return request.get(url)
                .then(res => {
                    $rootScope.currentUser = res.data;
                    $rootScope.tenantCover = res.data.tenant.publicFolderUrl;
                    return res.data
                })
        }

        const getCurrentUser = () => {
            if (!$rootScope.currentUser && auth.isAuthenticated()) {
                return getUserInfo()
            } else {
                return $q.resolve($rootScope.currentUser);
            }
        };

        return {
            forgotPassword: forgotPassword,
            resetPassword: resetPassword,
            getUserInfo: getUserInfo,
            getCurrentUser: getCurrentUser
        }

    }

})();